import React from 'react';

import initReactApp from 'dpl/util/initReactApp';
import GlobalMobileMenuNavigationButtonContainer from 'dpl/containers/GlobalMobileMenu/GlobalMobileMenuNavigationButtonContainer';
import BreederApplicationContainer from 'dpl/join_as_breeder/containers/BreederApplicationContainer';
import BreederJoinSoftwareSectionContainer from 'dpl/join_as_breeder/containers/SoftwareSectionV3Container';
import BreederJoinFaqsSection from 'dpl/join_as_breeder/components/BreederJoinFaqs';
import BreederJoinTrustSection from 'dpl/common/components/TrustSection';
import MobileNavigationMenuContainer from 'dpl/join_as_breeder/containers/MobileNavigationMenuContainer';
import BreederQuoteCarouselContainer from 'dpl/join_as_breeder/containers/BreederQuoteCarouselContainer';
import { BREEDER_APPLICATION_IDS } from 'dpl/join_as_breeder/utils/constants';
import MobileBreederJoinNavigation from 'dpl/join_as_breeder/components/MobileBreederJoinNavigation';

initReactApp({
  MobileNavigationMenuContainer,
  BreederJoinSoftwareSectionContainer,
  /* eslint-disable react/display-name */
  MobileNavigationMenuButton: () => (
    <GlobalMobileMenuNavigationButtonContainer />
  ),
  BreederApplicationContainer: () => (
    <BreederApplicationContainer
      sectionId={BREEDER_APPLICATION_IDS.SPLASH}
      animateArrow
      withArrow
      text="Get started"
      variant="white"
      className="dib f4-xl pv5 ph8 ph12-xl bw0"
    />
  ),
  BreederJoinMissionApplicationContainer: () => (
    <BreederApplicationContainer
      sectionId={BREEDER_APPLICATION_IDS.RIGHT_TO_BREED}
      text="Join us today"
      variant="white"
      className="d-lg-inline-block d-block f4-xl ph14 pv4 w-auto w-100-ns"
    />
  ),
  BreederJoinNavigationApplicationContainer: () => (
    <BreederApplicationContainer
      sectionId={BREEDER_APPLICATION_IDS.HEADER}
      className="w-100 w-auto-ns pv3"
      withBadge
    />
  ),
  MobileBreederJoinNavigationApplicationContainer: () => (
    <MobileBreederJoinNavigation />
  ),
  BreederJoinHowToApplicationContainer: () => (
    <BreederApplicationContainer
      sectionId={BREEDER_APPLICATION_IDS.GOOD_BREEDER}
      text="Get started"
      className="w-100 w-auto-ns pv3 ph16"
    />
  ),
  BreederCollageApplicationContainer: () => (
    <BreederApplicationContainer
      className="button button--secondary dib f4-xl pv3 pv5-lg ph8 ph12-xl mb12 mb0-lg bw0"
      text="Join us today"
    />
  ),
  /* eslint-enable react/display-name */
  BreederQuoteCarouselContainer,
  BreederJoinFaqsSection,
  BreederJoinTrustSection
});
